// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"417":"d97b92f7","488":"332d7654"}[chunkId] + ".chunk.js";
};